export default __webpack_public_path__ + "static/get-info-7763a04c193275481595508e3d51e0ea.jpg";